module.exports = __webpack_public_path__ + "media/images/pic/courses/monika-zachaj-c7985e1aaa55b17a98e6814af70e3513.png";